// test1759
(1759 && 0);
